import metaFieldIcon from './icons';
import attributeVisibility from '@components/visibility/attributes.json';
import { getBlockLabelByName } from '@helpers/utils';
import metaFieldBlockMeta from './block.json';
import edit from './edit';
import './style.scss';

const {
  blocks: { registerBlockType },
} = wp;
const { name, ...settings } = metaFieldBlockMeta;

const attributes = {
  ...settings.attributes,
  ...attributeVisibility,
};

registerBlockType(name, {
  icon: metaFieldIcon,
  ...settings,
  attributes,
  edit,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
